import http from '../../../../api/http';

function retrieveAllPaging(paramObj) {
    return http.post('/insights/newsletter/retrieveAllPaging', {
        pageNumber: paramObj.pageNo,
        size: paramObj.size,
        searchType: paramObj.searchType,
        searchInput: paramObj.searchInput,
    })
}

function retrieveNewsletterDetail(newsletterId) {
    return http.post('/insights/newsletter/retrieve', {
        newsletterId
    });
}

function createNewsletter(paramObj) {
    return http.post('/insights/newsletter/create', {
        newsletterId: paramObj.newsletterId, // 0,
        title: paramObj.title, // "string",
        newsletterThumbName: paramObj.newsletterThumbName,
        newsletterThumbSize: paramObj.newsletterThumbSize,
        newsletterThumbDir: paramObj.newsletterThumbDir,
        hitCount: paramObj.hitCount, // 0,
        content: paramObj.content, // "string",
        createId: paramObj.createId, // 0
        attachList: paramObj.attachList,
    });
}

function updateNewsletter(paramObj) {
    return http.post('/insights/newsletter/update', {
        newsletterId: paramObj.newsletterId, // 0,
        title: paramObj.title, // "string",
        newsletterThumbName: paramObj.newsletterThumbName,
        newsletterThumbSize: paramObj.newsletterThumbSize,
        newsletterThumbDir: paramObj.newsletterThumbDir,
        hitCount: paramObj.hitCount, // 0,
        content: paramObj.content, // "string",
        createId: paramObj.createId, // 0
        attachList: paramObj.attachList,
    });
}

function deleteNewsletter(newsletterId) {
    return http.post('/insights/newsletter/delete', {
        newsletterId
    });
}

export default {
    retrieveAllPaging,
    retrieveNewsletterDetail,
    createNewsletter,
    updateNewsletter,
    deleteNewsletter,
};